export default "__VITE_ASSET__CyPFKEhH__"